import { useLayoutEffect, useRef } from "react";
import BannerContent from "./components/BannerContent";

const HEIGHT_VARIABLE = "--status-banner-height";

/**
 * Stays under the header on every page while a vendor has something to act
 * on. Its height is published as a CSS variable so full-height pages, sized
 * with headerOffset(), shrink to make room instead of scrolling.
 */
const VendorStatusBanner: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }
    const root = document.documentElement.style;
    let frame = 0;
    const write = () => {
      const height = `${element.offsetHeight}px`;
      if (root.getPropertyValue(HEIGHT_VARIABLE) !== height) {
        root.setProperty(HEIGHT_VARIABLE, height);
      }
    };
    // Writing inside the observer callback resizes the page in the same frame,
    // which the browser reports as "ResizeObserver loop completed".
    const publish = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(write);
    };

    write();
    // Wraps to more lines on narrow screens, and changes with the message.
    const observer = new ResizeObserver(publish);
    observer.observe(element);
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      root.removeProperty(HEIGHT_VARIABLE);
    };
  }, []);

  return (
    <div ref={ref}>
      <BannerContent />
    </div>
  );
};

export default VendorStatusBanner;
